<div
  *ngIf="isVisible"
  [class.app-aside-menu--collapsed]="isAsideCollapsed"
  [class.app-aside-menu--expanded]="isExpanded"
  class="app-aside-menu"
>
  <div class="app-aside-menu__content">
    <div class="app-aside-menu__content__header">
      <app-section-title
        [sectionTitleIcon]="sectionIcon"
        [sectionTitleTitle]="sectionTitle | translate"
        data-cy="aside-menu-section-title"
      ></app-section-title>
      <qima-button-icon
        (qimaButtonIconClick)="onCloseClick()"
        [qimaButtonIconName]="closeIconName"
        [qimaButtonIconSize]="closeButtonSize"
        [qimaButtonIconStyle]="closeButtonIconStyle"
        data-cy="aside-menu-close-button"
      ></qima-button-icon>
    </div>
    <div class="app-aside-menu__content__service">
      <div class="app-aside-menu__content__service__left">
        <app-previous-order-item
          *ngIf="isFoodCertification"
          [previousOrderItemIsTitleVisible]="false"
          data-cy="aside-menu-previous-order"
        ></app-previous-order-item>

        <qima-divider
          *ngIf="isFoodCertification"
          [qimaDividerOrientation]="dividerOrientation"
          class="qima-mt-xs qima-mb-xs"
        ></qima-divider>

        <div
          *ngIf="isFoodCertification"
          class="app-aside-menu__content__service__left__sub-title"
        >
          <app-section-title
            [sectionTitleIcon]="serviceIcon"
            [sectionTitleTitle]="'APP_BOOK_SUB_MENU.TITLE_BOOK_NEW' | translate"
          ></app-section-title>
        </div>

        <app-aside-menu-item
          (asideMenuItemClick)="onAsideMenuBusinessSolutionClick(index)"
          *ngFor="let item of businessSolutions; let index = index"
          appNgForTrackByUuid
          [asideMenuItemLabel]="item.label | translate"
          [class.app-aside-menu__content__service__left__aside-menu]="!isAcaFrameAvailable"
          [isAsideMenuItemChecked]="index === asideMenuBusinessSolutionIndex"
          [isAsideMenuItemIconShow]="true"
          [attr.data-cy]="'aside-menu-business-solution-' + index"
        ></app-aside-menu-item>

        <qima-divider
          *ngIf="!isFoodCertification"
          [qimaDividerOrientation]="dividerOrientation"
          class="qima-mt-xs qima-mb-xs"
        ></qima-divider>

        <app-previous-order-item
          *ngIf="!isFoodCertification"
          data-cy="aside-menu-previous-order"
        ></app-previous-order-item>
      </div>
      <qima-divider
        *ngIf="isExpanded"
        [qimaDividerOrientation]="qimaDivider.orientation.VERTICAL"
        [qimaDividerStyle]="dividerStyle"
      ></qima-divider>
      <div
        *ngIf="isExpanded"
        class="app-aside-menu__content__service__right"
      >
        <app-aside-menu-item
          (asideMenuItemClick)="onAsideMenuServiceTypeClick(index, item)"
          *ngFor="let item of serviceTypesActive; let index = index"
          appNgForTrackByUuid
          [asideMenuItemAbbreviation]="item.abbreviation || ''"
          [asideMenuItemLabel]="item.label | translate"
          [class.app-aside-menu__content__service__right__aside-menu--disabled]="!item.path"
          [isAsideMenuItemChecked]="index === asideMenuServiceTypeIndex"
          [attr.data-cy]="'aside-menu-service-type-' + index"
        ></app-aside-menu-item>
      </div>
    </div>
  </div>
</div>
